import { validarResultado } from "./validarResultado";

export async function getFetch(url, callbackSucesso, callbackErro, callbackErroConexao, exibirToastErroConexao, exibirToastErroServidor) {
    const retorno = await fetch(url, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
        }
    });

    return validarResultado(retorno, callbackSucesso, callbackErro, callbackErroConexao, exibirToastErroConexao, exibirToastErroServidor);
}
